import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  className?: string;
}

const KlubMuteluIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#56053F",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.8461 24.3087C35.746 24.9737 35.4633 25.4577 34.8732 25.7342C34.2694 26.0172 33.6211 26.0088 33.1324 25.5668C31.8404 24.398 30.5717 23.2032 29.3476 21.9703C28.763 21.3815 28.8781 20.4572 29.4779 19.9007C30.0759 19.346 31.0383 19.2688 31.6594 19.8297C32.9261 20.9738 34.1563 22.1559 35.365 23.3556C35.6086 23.5975 35.69 23.9871 35.8461 24.3087Z"
        fill={color}
      />
      <path
        d="M62.2929 25.9775C61.5783 25.8836 61.0617 25.6077 60.7726 25.0161C60.4861 24.4299 60.5291 23.8291 60.9945 23.3667C62.2024 22.1665 63.4362 20.9882 64.6988 19.84C65.3271 19.2686 66.3253 19.3456 66.9235 19.9213C67.5021 20.4781 67.588 21.4142 67.0041 21.998C65.7878 23.214 64.5299 24.3935 63.2556 25.5548C63.0143 25.7747 62.6178 25.8406 62.2929 25.9775Z"
        fill={color}
      />
      <path
        d="M46.5552 15.2095C46.5555 14.6557 46.5434 14.1016 46.5583 13.5482C46.5815 12.6837 47.2628 12.0259 48.1397 12.0007C49.0056 11.9758 49.784 12.6045 49.817 13.4559C49.8626 14.631 49.8617 16.5841 49.819 17.7594C49.787 18.6361 49.0006 19.2633 48.1007 19.223C47.2249 19.1838 46.5752 18.5265 46.5571 17.6449C46.5458 17.0913 46.555 15.7632 46.5552 15.2095Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.6537 43.4484C65.6537 53.0979 57.8313 60.9203 48.1818 60.9203C38.5324 60.9203 30.71 53.0979 30.71 43.4484C30.71 33.799 38.5324 25.9766 48.1818 25.9766C57.8313 25.9766 65.6537 33.799 65.6537 43.4484ZM58.6677 43.4497C58.6677 37.66 53.9743 32.9666 48.1846 32.9666V53.9328C53.9743 53.9328 58.6677 49.2393 58.6677 43.4497Z"
        fill={color}
      />
      <path
        d="M31.7354 65.9674C31.296 65.3026 31.7727 64.416 32.5696 64.416H63.784C64.5829 64.416 65.0593 65.3066 64.6158 65.9711L59.4052 73.7782C59.2197 74.0561 58.9076 74.223 58.5735 74.223H37.7297C37.3939 74.223 37.0806 74.0545 36.8954 73.7744L31.7354 65.9674Z"
        fill={color}
      />
      <path
        d="M87.5285 69.0184C86.5123 67.6207 85.4979 66.2216 84.4623 64.8375C84.2238 64.5192 84.1576 64.2256 84.22 63.8413C84.8257 60.1117 87.0545 53.9968 85.9724 50.4395C85.2974 48.2203 84.5674 46.0166 83.8548 43.8079C82.4011 39.2988 80.2281 32.5662 79.489 30.2837C78.7498 28.0012 75.841 26.5152 73.7472 28.4475C71.6725 30.3621 72.6994 33.6147 73.5122 36.2744C74.3029 38.862 75.21 44.5557 74.2668 50.4849C73.3234 56.4153 70.5683 61.4136 69.1518 63.6839C68.7434 64.3372 67.0322 66.3624 69.8876 70.2634C71.6002 72.6031 73.309 74.9451 75.0359 77.275C75.9311 78.4818 76.8165 79.1689 78.1728 78.2314C80.8682 76.3642 84.4101 73.5882 87.0945 71.7059C88.134 70.9772 88.2812 70.0538 87.5285 69.0184Z"
        fill={color}
      />
      <path
        d="M68.0028 54.2199C67.9636 52.4354 69.3209 50.9557 71.0343 50.9149C72.7478 50.8741 74.1686 52.2877 74.2078 54.0721L74.4766 66.3167C74.5157 68.1012 73.1585 69.5808 71.445 69.6216C69.7315 69.6624 68.3107 68.2489 68.2716 66.4644L68.0028 54.2199Z"
        fill={color}
      />
      <path
        d="M8.47447 69.0184C9.49068 67.6207 10.505 66.2216 11.5407 64.8375C11.7791 64.5192 11.8453 64.2256 11.7829 63.8413C11.1772 60.1117 8.94843 53.9968 10.0305 50.4395C10.7056 48.2203 11.4356 46.0166 12.1481 43.8079C13.6019 39.2988 15.7748 32.5662 16.514 30.2837C17.2531 28.0012 20.162 26.5152 22.2557 28.4475C24.3304 30.3621 23.3035 33.6147 22.4908 36.2744C21.7 38.862 20.7929 44.5557 21.7361 50.4849C22.6795 56.4153 25.4346 61.4136 26.8511 63.6839C27.2595 64.3372 28.9708 66.3624 26.1153 70.2634C24.4028 72.6031 22.6939 74.9451 20.967 77.275C20.0718 78.4818 19.1864 79.1689 17.8302 78.2314C15.1347 76.3642 11.5929 73.5882 8.90843 71.7059C7.86894 70.9772 7.7217 70.0538 8.47447 69.0184Z"
        fill={color}
      />
      <path
        d="M28.0031 54.2199C28.0423 52.4354 26.685 50.9557 24.9715 50.9149C23.2581 50.8741 21.8373 52.2877 21.7981 54.0721L21.5293 66.3167C21.4901 68.1012 22.8474 69.5808 24.5609 69.6216C26.2743 69.6624 27.6951 68.2489 27.7343 66.4644L28.0031 54.2199Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubMuteluIcon;
